import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';

export default class extends Route {
  @service declare router: RouterService;

  // model comes from the parent funds.fund.more.tnt-connect-import.xml route
  // model()

  redirect(model: any) {
    if (model.selectedFile == null) {
      // confirm a file has been selected
      this.router.transitionTo('funds.fund.more.tnt-connect-import.xml');
    }
  }
}
